import { useAsdpApi } from '../../useAsdpApi';
import { useInbox } from './useInbox';

const BADGE_POLL_MS = 5 * 60_000;

/** The "Needs you" count beside the Applications nav item. */
export const NeedsYouNavBadge = () => {
  const api = useAsdpApi({ optional: true });
  const { items } = useInbox(api, BADGE_POLL_MS);
  const count = items?.length ?? 0;
  if (count === 0) return null;
  return (
    <span className="ml-auto rounded-full bg-warning-subtle px-1.5 text-[11px] font-semibold tabular-nums text-warning-strong">
      <span aria-hidden="true">{count}</span>
      <span className="sr-only">
        , {count} {count === 1 ? 'item needs' : 'items need'} you
      </span>
    </span>
  );
};
